import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';

export const routes: Routes = [
  {
    path: '',
    canActivate: [MsalGuard],
    canActivateChild: [MsalGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        path: 'under-construction',
        loadComponent: () =>
          import('./components/under-construction/under-construction.component').then(
            m => m.UnderConstructionComponent
          ),
      },
      {
        path: 'dashboard',
        title: 'Dashboard',
        loadComponent: () =>
          import('./components/dashboard/workflow-dashboard.component').then(
            m => m.WorkflowDashboardComponent
          ),
      },
      {
        path: 'releases',
        title: 'Releases',
        loadComponent: () =>
          import('./components/releases/release-dashboard.component').then(
            m => m.ReleaseDashboardComponent
          ),
      },
      {
        path: 'releases/:id',
        title: 'Release Detail',
        loadComponent: () =>
          import('./components/releases/release-detail.component').then(
            m => m.ReleaseDetailComponent
          ),
      },
      {
        path: 'publish',
        title: 'Publish',
        loadComponent: () =>
          import('./components/publish/publish-landing.component').then(
            m => m.PublishLandingComponent
          ),
      },
      {
        path: 'release/in-flight',
        title: 'In-flight Publish',
        loadComponent: () =>
          import('./components/publish/inflight/inflight-publish.component').then(
            m => m.InflightPublishComponent
          ),
      },
      {
        path: 'publish/container',
        title: 'Publish OCI Artifact',
        loadComponent: () =>
          import('./models/scenarios/publish-container/publish-container-scenario.component').then(
            m => m.PublishContainerScenarioComponent
          ),
      },
      {
        path: 'workflow',
        children: [
          {
            path: '',
            title: 'Workflows',
            loadComponent: () =>
              import('./components/workflow/workflows-list/workflows-list.component').then(
                m => m.WorkflowsListComponent
              ),
          },
          {
            path: 'wizard',
            title: 'Create Workflow',
            loadComponent: () =>
              import('./components/workflow/template-selection/template-selection.component').then(
                m => m.TemplateSelectionComponent
              ),
          },
          {
            path: 'wizard/package-scenario',
            title: 'Build Package(s)',
            loadComponent: () =>
              import('./models/scenarios/package/package-scenario-wizard.component').then(
                m => m.PackageScenarioWizardComponent
              ),
          },
          {
            path: 'wizard/allowlist-scenario',
            title: 'Koji Allowlist',
            loadComponent: () =>
              import('./models/scenarios/allowlist/allowlist-scenario.component').then(
                m => m.AllowlistScenarioComponent
              ),
          },
          {
            path: 'wizard/regenrepo-scenario',
            title: 'Regenerate Koji Repo',
            loadComponent: () =>
              import('./models/scenarios/regenrepo/regenrepo-scenario.component').then(
                m => m.RegenRepoScenarioComponent
              ),
          },
          {
            path: 'wizard/package-scenario-official',
            title: 'Build Package(s) - Official',
            loadComponent: () =>
              import('./models/scenarios/package-official/package-official-scenario-wizard.component').then(
                m => m.PackageOfficialScenarioWizardComponent
              ),
          },
          {
            path: 'wizard/image-scenario',
            title: 'Image Build',
            loadComponent: () =>
              import('./models/scenarios/image/image-scenario-modal.component').then(
                m => m.ImageScenarioComponent
              ),
          },
          {
            path: 'wizard/image-scenario-custom',
            title: 'Build Custom Image',
            loadComponent: () =>
              import('./models/scenarios/custom-image/custom-image-scenario-modal.component').then(
                m => m.CustomImageScenarioComponent
              ),
          },
          {
            path: 'wizard/image-scenario-official',
            title: 'Build Images - Official',
            loadComponent: () =>
              import('./models/scenarios/image-official/image-official-scenario-wizard.component').then(
                m => m.ImageOfficialScenarioWizardComponent
              ),
          },
          {
            path: 'wizard/custom-image-validation',
            title: 'Custom Image Validation',
            loadComponent: () =>
              import('./models/scenarios/custom-image-validation/custom-image-validation-wizard.component').then(
                m => m.CustomImageValidationWizardComponent
              ),
          },
          {
            path: 'wizard/branch-scenario',
            title: 'Build Branch',
            loadComponent: () =>
              import('./models/scenarios/branch/branch-scenario-wizard.component').then(
                m => m.BranchScenarioWizardComponent
              ),
          },
          {
            path: 'wizard/json-flow',
            title: 'JSON Flow Wizard',
            loadComponent: () =>
              import('./components/workflow/wizard/flows/json-flow/json-flow-wizard.component').then(
                m => m.JsonFlowWizardComponent
              ),
          },
          {
            path: 'wizard/release-publish',
            title: 'Publish Release Images',
            loadComponent: () =>
              import('./components/workflow/wizard/flows/release-publish/release-publish-wizard.component').then(
                m => m.ReleasePublishWizardComponent
              ),
          },
          {
            path: 'plan/:planId',
            title: 'Plan Detail',
            loadComponent: () =>
              import('./components/workflow/plan-review/workflow-plan-review.component').then(
                m => m.WorkflowPlanReviewComponent
              ),
          },
          {
            path: 'wizard/under-construction',
            redirectTo: '/under-construction',
          },
          {
            path: ':id',
            title: 'Workflow Detail',
            loadComponent: () =>
              import('./components/workflow/workflow-details/package-flow-detail/package-flow-detail.component').then(
                m => m.PackageFlowDetailComponent
              ),
          },
          {
            path: 'job/:id/koji-summary',
            title: 'Koji Summary',
            loadComponent: () =>
              import('./components/workflow/workflow-details/shared/workflow-logs/workflow-logs.component').then(
                m => m.WorkflowLogsComponent
              ),
          },
          {
            path: 'job/:id/artifacts-summary',
            title: 'Artifacts Summary',
            loadComponent: () =>
              import('./components/workflow/workflow-details/shared/workflow-artifacts-summary/workflow-artifacts-summary.component').then(
                m => m.WorkflowArtifactsSummaryComponent
              ),
          },
          {
            path: 'job/:id/logs-full',
            title: 'Full Log Viewer',
            loadComponent: () =>
              import('./components/workflow/workflow-details/shared/workflow-logs-full/workflow-logs-full.component').then(
                m => m.WorkflowLogsFullComponent
              ),
          },
        ],
      },
      {
        path: 'plans',
        title: 'Plans',
        loadComponent: () =>
          import('./components/plans/plans-list/plans-list.component').then(
            m => m.PlansListComponent
          ),
      },
      // The four Components tabs share one component; `scope` selects the view.
      // These literal paths MUST stay ahead of 'packages/:id' or they resolve as an id.
      {
        path: 'packages',
        title: 'My Components',
        data: { scope: 'mine' },
        loadComponent: () =>
          import('./components/packages/components-list/components-list.component').then(
            m => m.ComponentsListComponent
          ),
      },
      {
        path: 'packages/official',
        title: 'Official Components',
        data: { scope: 'official' },
        loadComponent: () =>
          import('./components/packages/components-list/components-list.component').then(
            m => m.ComponentsListComponent
          ),
      },
      {
        path: 'packages/unofficial',
        title: 'Unofficial Components',
        data: { scope: 'unofficial' },
        loadComponent: () =>
          import('./components/packages/components-list/components-list.component').then(
            m => m.ComponentsListComponent
          ),
      },
      {
        path: 'packages/components',
        title: 'All Components',
        data: { scope: 'all' },
        loadComponent: () =>
          import('./components/packages/components-list/components-list.component').then(
            m => m.ComponentsListComponent
          ),
      },
      {
        path: 'packages/components/:name',
        title: 'Component Builds',
        loadComponent: () =>
          import('./components/packages/component-builds/component-builds.component').then(
            m => m.ComponentBuildsComponent
          ),
      },
      {
        path: 'packages/:id',
        title: 'Package Detail',
        loadComponent: () =>
          import('./components/packages/packages-detail/packages-detail.component').then(
            m => m.PackagesDetailComponent
          ),
      },
      // The four Images tabs share one component; `scope` selects the view.
      {
        path: 'images',
        title: 'My Images',
        data: { scope: 'mine' },
        loadComponent: () =>
          import('./components/images/images-list/images-list.component').then(
            m => m.ImagesListComponent
          ),
      },
      {
        path: 'images/official',
        title: 'Official Images',
        data: { scope: 'official' },
        loadComponent: () =>
          import('./components/images/images-list/images-list.component').then(
            m => m.ImagesListComponent
          ),
      },
      {
        path: 'images/unofficial',
        title: 'Unofficial Images',
        data: { scope: 'unofficial' },
        loadComponent: () =>
          import('./components/images/images-list/images-list.component').then(
            m => m.ImagesListComponent
          ),
      },
      {
        path: 'images/all',
        title: 'All Images',
        data: { scope: 'all' },
        loadComponent: () =>
          import('./components/images/images-list/images-list.component').then(
            m => m.ImagesListComponent
          ),
      },
      {
        path: 'images/all/:name',
        title: 'Image Builds',
        loadComponent: () =>
          import('./components/images/image-builds/image-builds.component').then(
            m => m.ImageBuildsComponent
          ),
      },
      {
        path: 'images/detail/:id',
        title: 'Image Detail',
        loadComponent: () =>
          import('./components/images/image-detail/image-detail.component').then(
            m => m.ImageDetailComponent
          ),
      },
      {
        path: 'admin/hangfire',
        title: 'Hangfire Dashboard',
        loadComponent: () =>
          import('./components/admin/hangfire-access/hangfire-access.component').then(
            m => m.HangfireAccessComponent
          ),
      },
      {
        path: 'system-health',
        title: 'System Health',
        loadComponent: () =>
          import('./components/system-health/system-health.component').then(
            m => m.SystemHealthComponent
          ),
      },
      {
        path: 'statistics',
        title: 'Statistics',
        loadComponent: () =>
          import('./components/statistics/statistics.component').then(
            m => m.StatisticsComponent
          ),
      },
      {
        path: 'build-metrics',
        title: 'Build Metrics',
        loadComponent: () =>
          import('./components/build-metrics/build-metrics.component').then(
            m => m.BuildMetricsComponent
          ),
      },
      {
        path: 'test-results-by-workflow',
        title: 'Test Results by Workflow',
        loadComponent: () =>
          import('./components/test-results-by-workflow/test-results-by-workflow.component').then(
            m => m.TestResultsByWorkflowComponent
          ),
      },
      {
        path: 'test-results-by-run-id',
        redirectTo: 'test-results-by-workflow',
      },
      {
        // Not linked from the navigation yet; reachable by URL only.
        path: 'release-health',
        title: 'Release Health',
        loadComponent: () =>
          import('./components/release-health/release-health.component').then(
            m => m.ReleaseHealthComponent
          ),
      },
      {
        path: '**',
        redirectTo: 'under-construction',
      },
    ],
  },
];
